<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1250px"
      title="丘成桐少年班六年级"
      id-key="Junior6Id"
      :data="data"
      form-label-width="85px"
      :form-rules="rules"
      :save-func="api.save"
      :get-data-func="api.info"
      :before-save="onBeforeSave"
      @details-opened="onDetailsOpened"
      @create-opened="onCreateOpened"
      @closed="onClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="24">
            <table class="report-table no-border" border="1">
              <tr>
                <td colspan="25">
                  <div v-if="data.EnrollNo">报名序号：{{data.EnrollNo}}</div>
                  <span v-else>报名序号：(<span class="red">系统自动生成</span>)</span>
                  <div class="center large" style="margin:6px 0;">{{year}}年汕头市金山中学“丘成桐少年班”六年级学生报名信息表</div>
                </td>
              </tr>
              <tr>
                <td class="center" style="width:10%;">姓名</td>
                <td class="center" colspan="9" style="width:32.5%;">
                  {{data.FullName}}
                </td>
                <td class="center" style="width:10%;">性别</td>
                <td class="center" colspan="9" style="width:32.5%;">
                  <span>{{data.Sex==1?"男":"女"}}</span>
                </td>
                <td class="center red bold small" rowspan="5" style="width:15%;">
                  <el-image v-if="!tbLoading" :src="'/api'+data.PicUrl" fit="cover" :preview-src-list="['/api'+data.PicUrl]" style="height: 180px;width: 90%;margin-top: 6px;" />
                </td>
              </tr>
              <tr>
                <td class="center" style="width:10%;">身份证</td>
                <td class="center" colspan="9">
                  <span>{{data.IdCard}}</span>
                </td>
                <td class="center" style="width:10%;">户籍地</td>
                <td class="center" colspan="9">
                  <span>{{data.Domicile}}</span>
                </td>
              </tr>
              <tr>
                <td class="center" style="width:10%;">出生日期</td>
                <td class="center" colspan="9">
                  <span>{{toDateString(data.BirthDate)}}</span>
                </td>
                <td class="center small" style="width:10%;">就读小学所在<br/>区县</td>
                <td class="center" colspan="9">
                  <span>{{data.SchoolDistrict}}</span>
                </td>
              </tr>
              <tr>
                <td class="center" style="width:10%;">就读小学</td>
                <td class="center" colspan="19">
                  <span>{{data.PrimarySchool}}</span>
                </td>
              </tr>
              <tr>
                <td class="center small" style="width:10%;">家长手机号码</td>
                <td class="center" colspan="19">
                  <span>{{data.Mobile}}</span>
                </td>
              </tr>
              <tr>
                <td class="center bold" style="width:10%;">个人特长</td>
                <td class="center" style="width:16.25%;">等级</td>
                <td class="center" style="width:16.25%;">证书</td>
                <td class="center" colspan="22">表现说明</td>
              </tr>
              <tr>
                <td class="center" style="width:10%;height:34px;">
                  <span>{{data.SpecialName1}}</span>
                </td>
                <td class="center">
                  <span>{{data.SpecialLv1}}</span>
                </td>
                <td class="center">
                  <el-image v-if="data.SpecialCertUrl1&&!tbLoading" :src="'/api'+data.SpecialCertUrl1" fit="cover" :preview-src-list="['/api'+data.SpecialCertUrl1]" style="height: 120px;width: 90%;margin-top: 6px;" />
                </td>
                <td class="center" colspan="22">
                  <span>{{data.SpecialRemark1}}</span>
                </td>
              </tr>
              <tr>
                <td class="center" style="width:10%;height:34px;">
                  <span>{{data.SpecialName2}}</span>
                </td>
                <td class="center">
                  <span>{{data.SpecialLv2}}</span>
                </td>
                <td class="center">
                  <el-image v-if="data.SpecialCertUrl2&&!tbLoading" :src="'/api'+data.SpecialCertUrl2" fit="cover" :preview-src-list="['/api'+data.SpecialCertUrl2]" style="height: 120px;width: 90%;margin-top: 6px;" />
                </td>
                <td class="center" colspan="22">
                  <span>{{data.SpecialRemark2}}</span>
                </td>
              </tr>
              <tr>
                <td class="center bold" style="width:10%;">竞赛获奖</td>
                <td class="center">等级(区县以上)</td>
                <td class="center">证书</td>
                <td class="center" colspan="22">表现说明</td>
              </tr>
              <tr>
                <td class="center" style="width:10%;height:34px;">
                  <span>{{data.AwardName1}}</span>
                </td>
                <td class="center">
                  <span>{{data.AwardLv1}}</span>
                </td>
                <td class="center">
                  <el-image v-if="data.AwardlCertUrl1&&!tbLoading" :src="'/api'+data.AwardlCertUrl1" fit="cover" :preview-src-list="['/api'+data.AwardlCertUrl1]" style="height: 120px;width: 90%;margin-top: 6px;" />
                </td>
                <td class="center" colspan="22">{{data.AwardRemark1}}</td>
              </tr>
              <tr>
                <td class="center" style="width:10%;height:34px;">
                  <span>{{data.AwardName2}}</span>
                </td>
                <td class="center">
                  <span>{{data.AwardLv2}}</span>
                </td>
                <td class="center">
                  <el-image v-if="data.AwardlCertUrl2&&!tbLoading" :src="'/api'+data.AwardlCertUrl2" fit="cover" :preview-src-list="['/api'+data.AwardlCertUrl2]" style="height: 120px;width: 90%;margin-top: 6px;" />
                </td>
                <td class="center" colspan="22">{{data.AwardRemark2}}</td>
              </tr>
              <tr>
                <td class="center" rowspan="3" style="width:10%;">承诺：</td>
                <td class="center" colspan="24">我们郑重承诺，以上所填内容完全真实准确。<br/>否则，愿意承担取消遴选资格或录取资格的后果。</td>
              </tr>
              <tr>
                <td class="center">家长签名：</td>
                <td class="center bold" colspan="23">
                  <el-image v-if="data.ParentSignUrl" :src="'/api'+data.ParentSignUrl" fit="contain" :preview-src-list="['/api'+data.ParentSignUrl]" style="height: 80px;width: 160px;" />
                  <span v-else>(确认提交本信息表后，默认家长和考生签名完成!)</span>
                </td>
              </tr>
              <tr>
                <td class="center">学生签名：</td>
                <td class="center">
                  <el-image v-if="data.StudentSignUrl" :src="'/api'+data.StudentSignUrl" fit="contain" :preview-src-list="['/api'+data.StudentSignUrl]" style="height: 80px;width: 160px;" />
                </td>
                <td class="center" colspan="23" v-if="data.AddTime">{{toYMString(data.AddTime)}}</td>
                <td class="center" colspan="23" v-else>{{year}}年{{month}}月</td>
              </tr>
              <tr>
                <td class="bold" colspan="25">
                  <span class="red">特别提示：</span>
                  <span class="blue">1、本表打印完成后，须在“电子彩照”位置贴上近期一寸彩照，并完成签名!!</span>
                  <div class="blue" style="text-indent:5rem;">2、本表于参加遴选时交给现场老师。</div>
                </td>
              </tr>
            </table>
          </el-col>
        </el-row>
      </template>
      <template slot="footer">
        <span class="statusText">状态：{{statusText}}</span>
        <template v-if="$permission.canWrite()">
          <el-button type="success" @click="uodateStatus(3)" v-if="data.Status==1">通 过</el-button>
          <el-button type="danger" @click="uodateStatus(2)" v-if="data.Status==1">不通过</el-button>
          <el-button type="warning" @click="uodateStatus(11)" v-if="data.Status==2||data.Status==3">撤销审核</el-button>
        </template>
        <el-button @click="close">关 闭</el-button>
      </template>
    </common-dialog>
  </div>
</template>
<script>
const date = new Date();
const year = date.getFullYear();
const month = date.getMonth() < 9 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;

import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      api: require("@/api/po/junior6").default,
      data: {
        Junior6Id: 0,
        ParentId: 0,
        EnrollNo: "",
        FullName: "",
        Sex: null,
        IdCard: "",
        Domicile: "",
        BirthDate: "",
        PrimarySchool: "",
        SchoolDistrict: "",
        Mobile: "",
        //------------
        SpecialName1: "",
        SpecialLv1: "",
        SpecialCertUrl1: "",
        SpecialRemark1: "",
        SpecialName2: "",
        SpecialLv2: "",
        SpecialCertUrl2: "",
        SpecialRemark2: "",
        AwardName1: "",
        AwardLv1: "",
        AwardlCertUrl1: "",
        AwardRemark1: "",
        AwardName2: "",
        AwardLv2: "",
        AwardlCertUrl2: "",
        AwardRemark2: "",
        //------------
        PicUrl: "",
        ParentSignUrl: "",
        StudentSignUrl: "",
        Status: 0,
      },
      tbLoading: true,
      setting: {
        EnableJunior6: true,
        SignStartDate: "",
        SignEndDate: "",
        PrintStartDate: "",
        PrintEndDate: "",
      },
      year,
      month,
      isMB: this.$store.state.isMB,
      rules: {
        
      },
    };
  },
  computed: {
    statusText() {
      var result = "";
      switch (this.data.Status) {
        case 0:
          result = "待提交";
          break;
        case 1:
          result = "待审核";
          break;
        case 2:
          result = "审核未通过";
          break;
        case 3:
          result = "审核通过";
          break;
      }
      return result;
    }
  },
  methods: {
    onCreateOpened() {
      this.tbLoading = false;
    },
    onDetailsOpened(data) {
      this.tbLoading = false;
      this.data.AddTime = data.AddTime;
    },
    uodateStatus(Status) {
      this.$confirm("确认操作吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.loading(true);
          this.api.updateStatus({ Ids: [this.data.Junior6Id], Status }).then(res => {
            this.loading(false);
            if(res.Code==0) {
              this.$message.success(res.Msg);
              this.close(true);
              this.$emit('close-saved');
            } else this.$message.error(res.Msg);
          })
        })
        .catch(() => {});
    },
    onBeforeSave() {
      return false;
    },
    toDateString(v) {
      if(!v) return "";
      var date = this.$commonJs.toDateString(v);
      var arr = date.split("/");
      return arr[0] + "年" + arr[1] + "月" + arr[2] + "日";
    },
    toYMString(v) {
      if(!v) return "";
      var date = this.$commonJs.toDateString(v);
      var arr = date.split("/");
      return arr[0] + "年" + arr[1] + "月";
    },
    onClosed() {
      this.tbLoading = true;
    },
  }
};
</script>
<style lang="scss">
.report-table {
  border-spacing: 0;
  border-collapse: collapse;
  width: 100%;
  font-size: 16px;
  td {
    padding: 6px 8px;
  }
  .el-input,.el-select {
    width: 100%;
  }
  .center {
    text-align: center;
  }
  .right {
    text-align: right;
  }
  .red {
    color: #f11;
  }
  .blue {
    color: #11f;
  }
  .small {
    font-size: 14px;
  }
  .large {
    font-size: 18px;
  }
}
.statusText {
  color:#F11;
  float:left;
  font-weight: bold;
  line-height: 34px;
  margin-left: 8px;
  font-size: 16px;
}
</style>